import EmptyState from 'components/EmptyState/EmptyState';

export const FinancialReportsEmptyState = () => {
  return (
    <div className="flex items-center justify-center w-full min-h-[calc(100vh-250px)]">
      <EmptyState
        title="No reports found"
        description={
          <>
            No reports match the filters you have selected.
            <br />
            Try clearing the filters or creating a new report.
          </>
        }
        icon="fa-regular fa-file-chart-column"
        hideButton
      />
    </div>
  );
};
